import { Component, Input, ViewEncapsulation, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { AppSettings } from '../../../../app.settings';
import { Settings } from '../../../../app.settings.model';
import { fadeIn } from 'src/app/theme/utils/app-animation';
import { MenuService } from 'src/app/shared/services/menu.service';
import { IMenu, defaultMenuId, landingPageMenuId } from 'src/app/shared/responses/imenu';
import * as debug from 'src/app/shared/services/debug.service';

@Component({
	selector: 'app-vertical-menu',
	templateUrl: './vertical-menu.component.html',
	styleUrls: ['./vertical-menu.component.scss'],
	encapsulation: ViewEncapsulation.None,
	animations: [fadeIn],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerticalMenuComponent implements AfterViewInit {

	@Input() menuParentId: number;
	@Input() menus: IMenu[];

	settings: Settings;

	constructor(private readonly appSettings: AppSettings, private readonly menuService: MenuService) {

		this.settings = this.appSettings.settings;

		debug.log(`088.0 VerticalMenuComponent instantiated menus:`, this.menus);

	}

	get menuItems(): IMenu[] {

		debug.log(`088.1.0 VerticalMenuComponent this.menuParentId = ${this.menuParentId} menus:`, this.menus);

		if (!this.menus && this.menus.length <= 0) {

			debug.log(`088.1.1 VerticalMenuComponent menuItems = undefined`);

			return [];

		}

		const items = this.menus.filter(item => item.parentId === this.menuParentId && !item.menuLocation);
		// const items = this.menus.filter(item => item.parentId === this.menuParentId);

		debug.log(`088.1 VerticalMenuComponent this.menus:`, this.menus);
		debug.log(`088.2 VerticalMenuComponent menuParentId: ${this.menuParentId} menuItems:`, items);

		return !!items ? items : [];
	}

	onClick(menuId: number) {

		this.menuService.toggleMenuItem(menuId);

	}

	ngAfterViewInit(): void {

		this.menuService.expandActiveSubMenu('', '088.2 VerticalMenuComponent.ngAfterViewInit');

	}
}
